import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface ArticleCardProps {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  image: string;
  date: string;
  author: string;
  readTime: string;
  tags: string[];
}

function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
}

export default function ArticleCard({
  slug,
  title,
  category,
  excerpt,
  image,
  date,
  author,
  readTime,
  tags,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative overflow-hidden aspect-[16/10]">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-3">
          <Link
            to={`/category/${category}`}
            className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 whitespace-nowrap hover:bg-accent-200 transition-colors cursor-pointer"
          >
            {getCategoryName(category)}
          </Link>
          <span className="text-xs text-secondary-500">{date}</span>
          <span className="text-xs text-secondary-400">· {readTime}</span>
        </div>
        <Link to={`/article/${slug}`} className="block cursor-pointer">
          <h3 className="text-base font-medium text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-secondary-600 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <div className="flex items-center gap-2 flex-wrap">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-xs text-secondary-500 bg-secondary-50 px-2 py-0.5 rounded"
            >
              {tag}
            </span>
          ))}
          <span className="text-xs text-secondary-400 ml-auto">{author}</span>
        </div>
      </div>
    </article>
  );
}